<template>
  <el-dialog title="初核申请" :visible.sync="showDialog" append-to-body width="50%">
    <div class="text">
      在公证机构申请中，应当包括对下列内容的确认：<br>

        （一）经人脸识别设备或者其他身份验证系统确定人证同一；<br>

        （二）申请人与申请公证的事项有利害关系；<br>

        （三）申请人之间对申请公证的事项无争议；<br>

        （四）申请公证的事项符合《公证法》第十一条规定的范围；<br>

        （五）申请公证的事项符合《公证法》第二十五条的规定和该公证机构在其执业区域内可以受理公证业务的范围。<br>

      前款确认结果有一项不符合规定的，办证系统应当确定公证申请不予受理。
    </div>
    <div class="btns">
      <el-button size="small" type="primary" @click="approved">审批通过</el-button>
      <el-button size="small" @click="notApproved">不予受理</el-button>
    </div>
  </el-dialog>
</template>

<script>
import eventVue from "../event.js";
export default {
  props: {
    currCaseId: {
      required: true
    }
  },
  data() {
    return {
      showDialog: false
    }
  },
  methods: {
    open() {
      this.showDialog = true;
    },
    close() {
      this.showDialog = false;
    },
    // 审核通过
    approved() {
      console.log(this.currCaseId);
      this.$emit('approved');
      this.close();
    },
    notApproved() {
      this.close();
    }
  }
}
</script>
<style lang="less" scoped>
@import '../../../../style/mixin';
/deep/ .el-dialog__body {
  padding: 0 30px 30px 30px;
}
.text{
  line-height: 30px;
}
.btns{
  .flex(flex-end);
  margin-top: 20px;
}
</style>